import React, { useEffect, useRef, useState } from "react";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import Button from "../input/Button";
import SearchDropdown from "../input/SearchDropdown";
import LoadingSpinner from "../LoadingSpinner";

function InvoiceSearchComponent({
  searchResHandler,
  resetHandler = () => {},
  isHide = false,
  refresh,
  setRefresh,
}) {
  const [typeOptions, setTypeOptions] = useState([]);
  const [singleBulkOptions, setSingleBulkOptions] = useState([]);
  const [type, setType] = useState(null);
  const [jobCode, setJobCode] = useState("");
  const [invEvCode, setInvEvCode] = useState("");
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [customer, setCustomer] = useState("");
  const [transporter, setTransporter] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [singleBulk, setSingleBulk] = useState(1);
  const [reloadDates, setReloadDates] = useState(true);
  const customerRef = useRef();
  const transporterRef = useRef();
  const vehicleRef = useRef();
  const [dateType, setDateType] = useState("");
  const [dateTypeOpt, setDateTypeOpt] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  const [resetSearchFields, setResetSearchFields] = useState(false);

  useEffect(() => {
    (async () => {
      setDropdownLoading(true);
      const {
        rate_type_for: statusData = [],
        single_bulk: typeOpt = [],
        date_types: dateTypeData,
      } = await getBulkDropdownData([
        { key: "rate_type_for" },
        { key: "single_bulk" },
        { key: "date_types" },
      ]);
      setDateTypeOpt(dateTypeData);
      setTypeOptions(statusData);
      setSingleBulkOptions(typeOpt);
      setDropdownLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const onSearch = (e) => {
    e.preventDefault();
    searchResHandler({
      dateType: dateType ? dateType : null,
      type: type,
      jobCode: jobCode,
      invNo: invEvCode,
      fromDate: fromDate,
      toDate: toDate,
      transporter: transporter.toString(),
      customer: customer.toString(),
      vehicle: vehicle.toString(),
      singleBulk: singleBulk.toString(),
    });
  };

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setVehicle("");
    setCustomer("");
    setTransporter("");
    setReloadDates(true);
    setInvEvCode("");
    setSingleBulk(1);
    setType(null);
    resetHandler();
    customerRef.current.reset();
    transporterRef.current.reset();
    // vehicleRef.current.reset();
    setJobCode("");
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setDateType("");
  };

  useEffect(() => {
    if (refresh) {
      searchResHandler({
        dateType: dateType ? dateType : null,
        type: type,
        jobCode: jobCode,
        invNo: invEvCode,
        fromDate: fromDate,
        toDate: toDate,
        transporter: transporter.toString(),
        customer: customer.toString(),
        vehicle: vehicle.toString(),
        singleBulk: singleBulk.toString(),
      });
      setRefresh(false);
    }
  }, [refresh]);

  return (
    <>
      {dropdownLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <h4 className="ui dividing header">EV/INV Search</h4>
          <div
            className="three fields"
            style={{
              display: "Flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Dropdown
              required={true}
              clearable={false}
              label="Single / Bulk"
              placeholder="Single Bulk"
              options={singleBulkOptions}
              value={singleBulk}
              onChange={(e, data) => {
                setSingleBulk(data.value);
              }}
            />
            <Dropdown
              label="Type"
              placeholder="Type"
              options={typeOptions}
              value={type}
              onChange={(e, data) => {
                setType(data.value);
              }}
            />
            <Input
              label="Job Code"
              type="text"
              name="jobCode"
              value={jobCode}
              onChange={(e) => {
                setJobCode(e.target.value);
              }}
            />
          </div>
          <div
            className="three fields"
            style={{
              display: "Flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Dropdown
              // required={true}
              options={dateTypeOpt}
              label="Date Type"
              placeholder="Date Type"
              style={{ height: "20px" }}
              value={dateType}
              onChange={(e, data) => {
                setDateType(data.value);
              }}
              clearable={false}
            />

            <Input
              label="From Date"
              type="date"
              name="fromDate"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
            />
            <Input
              label="To Date"
              type="date"
              name="toDate"
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
            />
          </div>
          <div
            className={isHide ? "four fields" : "three fields"}
            style={{
              display: "Flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Input
              label="INV/EV Code"
              type="text"
              name="invEvCode"
              value={invEvCode}
              onChange={(e) => {
                setInvEvCode(e.target.value);
              }}
            />
            <SearchDropdown
              ref={customerRef}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setCustomer(data);
              }}
              clearable={true}
              onClear={() => {
                setCustomer("");
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{ type: "stakeholder_type", value: "Customer" }}
              label="Customer"
            />
            <SearchDropdown
              ref={transporterRef}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setTransporter(data);
              }}
              clearable={true}
              onClear={() => {
                setTransporter("");
              }}
              api={getOtherRefSearchDropdown}
              apiDependency={{ type: "stakeholder_type", value: "transporter_all" }}
              label="Transporter"
            />
            {isHide === true ? (
              <SearchDropdown
                ref={vehicleRef}
                editMode={false}
                reset={resetSearchFields}
                setReset={setResetSearchFields}
                onResultSelect={(data) => {
                  setVehicle(data);
                }}
                clearable={true}
                onClear={() => {
                  setVehicle("");
                }}
                api={getOtherRefSearchDropdown}
                apiDependency={{ type: "vehicle", value: "" }}
                label="Vehicle"
              />
            ) : (
              ""
            )}
          </div>
          <div className="field">
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <div className="field" style={{ width: "100%" }}>
                <Button template="search" onClick={onSearch} />
                <Button template="searchReset" onClick={onReset} />
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}

export default InvoiceSearchComponent;
